import { ScoopButton, ScoopSpinner, ScoopTextField } from '../../../ui'
import { LockKeyIcon } from '@phosphor-icons/react'
import styles from './RecoverPassword.module.scss'

export const RecoverPassword = ({
    recoverPasswordStep,
    email,
    emailError,
    newPassword,
    handleEmailChange,
    handleRecoverPasswordChange,
    handleStartPWDReset,
    handleFinishPWDReset,
    setStep,
    setIsLogin,
    isSignUpLoading,
    isSignInLoading,
}) => {
    const handleSubmitStep0 = (event) => {
        event.preventDefault()
        handleStartPWDReset()
    }

    const handleSubmitStep1 = (event) => {
        event.preventDefault()
        handleFinishPWDReset()
    }

    // Step 0: Email entry
    if (recoverPasswordStep === 0) {
        return (
            <div className={styles.signupContainer}>
                <div className={styles.formHeader}>
                    <div className={styles.emailIconWrapper}>
                        <LockKeyIcon size={32} weight="regular" />
                    </div>
                    <h2>Recover your password</h2>
                    <p>Enter your email to receive a recovery code</p>
                </div>

                <form onSubmit={handleSubmitStep0}>
                    <div className={styles.formGroup}>
                        <ScoopTextField
                            label="Email"
                            type="email"
                            id="email"
                            name="email"
                            placeholder="you@company.com"
                            value={email}
                            onChange={(e) => handleEmailChange(e.target.value)}
                            disableMargin
                        />
                        {emailError && <div className={styles.errorText}>{emailError}</div>}
                    </div>

                    <ScoopButton
                        variant="default"
                        size="fullWidth"
                        type="submit"
                        disabled={!email || !!emailError || isSignUpLoading || isSignInLoading}
                    >
                        {isSignUpLoading || isSignInLoading ? <ScoopSpinner /> : 'Send email'}
                    </ScoopButton>

                    <div className={styles.loginLink}>
                        Already have a Scoop account?{' '}
                        <span
                            onClick={() => {
                                setStep(0)
                                setIsLogin(true)
                            }}
                        >
                            Login here
                        </span>
                    </div>
                </form>
            </div>
        )
    }

    // Step 1: Code + New Password
    return (
        <div className={styles.signupContainer}>
            <div className={styles.formHeader}>
                <div className={styles.emailIconWrapper}>
                    <LockKeyIcon size={32} weight="regular" />
                </div>
                <h2>Reset your password</h2>
                <p>
                    Enter the code we sent to
                    <br />
                    <span className={styles.emailHighlight}>{email}</span>
                    <br />
                    and create a new password
                </p>
            </div>

            <form onSubmit={handleSubmitStep1}>
                <div className={styles.formGroup}>
                    <ScoopTextField
                        label="Verification Code"
                        type="text"
                        id="code"
                        name="code"
                        placeholder="Enter 6 digit code"
                        value={newPassword.code}
                        onChange={(e) => handleRecoverPasswordChange('code', e.target.value)}
                        disableMargin
                        maxLength={6}
                    />
                </div>

                <div className={styles.formGroup}>
                    <ScoopTextField
                        label="New Password"
                        type="password"
                        id="newPassword"
                        name="newPassword"
                        placeholder="Create a strong password"
                        value={newPassword.password}
                        onChange={(e) => handleRecoverPasswordChange('password', e.target.value)}
                        disableMargin
                    />
                </div>

                <div className={styles.formGroup}>
                    <ScoopTextField
                        label="Confirm Password"
                        type="password"
                        id="confirmPassword"
                        name="confirmPassword"
                        placeholder="Confirm your password"
                        value={newPassword.confirmPassword}
                        onChange={(e) =>
                            handleRecoverPasswordChange('confirmPassword', e.target.value)
                        }
                        disableMargin
                    />
                </div>

                <ScoopButton
                    variant="default"
                    size="fullWidth"
                    type="submit"
                    disabled={
                        !newPassword.code ||
                        !newPassword.password ||
                        !newPassword.confirmPassword ||
                        isSignUpLoading ||
                        isSignInLoading
                    }
                >
                    {isSignUpLoading || isSignInLoading ? <ScoopSpinner /> : 'Recover Password'}
                </ScoopButton>

                <div className={styles.loginLink}>
                    Already have a Scoop account?{' '}
                    <span
                        onClick={() => {
                            setStep(0)
                            setIsLogin(true)
                        }}
                    >
                        Login here
                    </span>
                </div>
            </form>
        </div>
    )
}
